import { render, staticRenderFns } from "./perFormance.vue?vue&type=template&id=4b4f706a&"
import script from "./perFormance.vue?vue&type=script&lang=js&"
export * from "./perFormance.vue?vue&type=script&lang=js&"
import style0 from "./perFormance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b4f706a')) {
      api.createRecord('4b4f706a', component.options)
    } else {
      api.reload('4b4f706a', component.options)
    }
    module.hot.accept("./perFormance.vue?vue&type=template&id=4b4f706a&", function () {
      api.rerender('4b4f706a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/perFormance.vue"
export default component.exports